import RestAPI from '../../../Common/restApi';

export default class AddJobApi {
  static searchCustomer(query) {
    let requestUrl = `/pro/add_request/customer_search?q=${encodeURIComponent(query)}`;
    return RestAPI.get(requestUrl);
  }

  static fetchCustomer(customer_id, service_address_id) {
    let requestUrl = '/pro/add_job_new/customer';
    let requestData = { customer_id: customer_id, address_id: service_address_id };
    return RestAPI.getWithFormData(requestUrl, requestData);
  }

  static addOneTimeJob(data, jobType) {
    let requestUrl = `/pro/add_${jobType.toLowerCase()}`;
    return RestAPI.postWithFormData(requestUrl, data);
  }

  static addRecurringJob(data) {
    let requestUrl = '/pro/add_recurring_job';
    return RestAPI.postWithFormData(requestUrl, data);
  }

  static addCustomerTag(customerId, tag) {
    let requestUrl = '/pro/customers/add_tag';
    let requestData = { tag_name: tag.name, customer_ids: [customerId] };
    return RestAPI.postWithFormData(requestUrl, requestData);
  }

  static deleteCustomerTag(customerId, tag) {
    let requestUrl = '/pro/customers/delete_tag';
    let requestData = { tag_name: tag.name, customer_ids: [customerId] };
    return RestAPI.postWithFormData(requestUrl, requestData);
  }

  static addAttachments(formData) {
    let requestUrl = '/pro/add_job/add_attachments';
    return RestAPI.postWithFormData(requestUrl, formData);
  }

  static filterEmployees(searchTerm) {
    let requestUrl = `/pro/add_request/employee_search?cal=true&q=${searchTerm}`;
    return RestAPI.get(requestUrl);
  }
}
